/* Add dot navigation without replacing the theme's slider/arrow/swipe behavior. */
if (!customElements.get('bistro-gallery-dots')) {
  customElements.define('bistro-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.slider = this.closest('slider-component');
      if (!this.slider) return;

      const sync = () => {
        this.querySelectorAll('[data-page]').forEach((button) => {
          button.setAttribute('aria-current', String(Number(button.dataset.page) === (this.slider.currentPage || 1)));
        });
      };

      this.slider.addEventListener('slideChanged', sync, { signal });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-page]');
        if (!button || !this.contains(button) || !this.slider.sliderItemOffset) return;
        this.slider.setSlidePosition((Number(button.dataset.page) - 1) * this.slider.sliderItemOffset);
      }, { signal });
      customElements.whenDefined('slider-component').then(() => {
        if (!signal.aborted) sync();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
